import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Project from '../Project/Project';
import './Projects.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch('projectsData.json')
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  return (
    <Container fluid="md">
      <Row className="justify-content-md-center">
        <Col lg="8" className="mt-5">
          <h1 className="text-center my-5">Explore my some new projects 👇</h1>
        </Col>
      </Row>
      <Row className="justify-content-sm-center">
        {projects?.slice(0, 9).map((myProject) => (
          <Project key={myProject.id} myProject={myProject}></Project>
        ))}
      </Row>
      <div className="mb-5">
        <button type="button" class="btn-All">
          <Link
            className="all-project text-decoration-none btn-All-link"
            to="/allProjects">
            Show More{' '}
            <FontAwesomeIcon className="delete-icon" icon={faArrowRight} />
          </Link>
        </button>
      </div>
    </Container>
  );
};

export default Projects;
